export class LoginReq {
  username: string = '';
  password: string = '';
}
